import { combineReducers } from 'redux';
import { authentication } from './authentication.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';

import { setPasswordReducer } from './User/setPassword.reducer';
import { forgotPasswordReducer } from './User/forgotPassword.reducer';

import { addOrgReducer } from './HomePage/Organisation/addOrg.reducer';
import { getOrgReducer } from './HomePage/Organisation/getOrgList.reducer';
import { getCountryListReducer } from './HomePage/getCountryList.reducer';

import { getOrgTeams } from './OrgAdmin/OrgTeam/getOrgTeam.reducer';
import { addOrgTeamReducer } from './OrgAdmin/OrgTeam/addOrgTeam.reducer';
import { editOrgTeamReducer } from './OrgAdmin/OrgTeam/editOrgTeam.reducer';
import { removeOrgTeamReducer } from './OrgAdmin/OrgTeam/removeOrgTeam.reducer';
import { getMemberLevel } from './OrgAdmin/MemberLevel/getMemberLevel.reducer';
import { changeMemberLevelReducer } from './OrgAdmin/MemberLevel/changeMemberLevel.reducer';
import { moveToDifferentTeamReducer } from './OrgAdmin/ManageTeam/moveToDifferentTeam.reducer';
import { resetTeamLeaderReducer } from './OrgAdmin/ManageTeam/resetTeamLeader.reducer';
import { getTeamMemberListReducer } from './OrgAdmin/ManageTeam/getTeamMemberList.reducer';
import { makeTeamLeaderReducer } from './OrgAdmin/ManageTeam/makeTeamLeader.reducer';
import { getOrgUsers } from './OrgAdmin/PaUsers/getOrgUsers.reducer';
import { addPaUsers } from './OrgAdmin/PaUsers/addPaUsers.reducer';
import { removePaUsers } from './OrgAdmin/PaUsers/removePaUsers.reducer';
import { getPaUserPermissionListReducer } from './OrgAdmin/PaUsers/getPaUserPermissionsList.reducer';
import { changeAccessReducer } from './OrgAdmin/PaUsers/changeAccess.reducer';
import { getMasterModuleListReducer } from './OrgAdmin/ModulePermissions/getMasterModuleList.reducer';
import { getModulePermissionsListReducer } from './OrgAdmin/ModulePermissions/getModulePermissions.reducer';
import { changeModuleAccessReducer } from './OrgAdmin/ModulePermissions/changeModuleAccess.reducer';
import { toggleAnalysisReducer } from './OrgAdmin/PaUsers/toggleAnalysis.reducer';

import { getOrgDetailsReducer } from './SuperAdmin/OrgDetails/getOrgDetails.reducer';
import { editOrgDetailsReducer } from './SuperAdmin/OrgDetails/editOrgDetails.reducer';
import { deleteOrgDetailsReducer } from './SuperAdmin/OrgDetails/deleteOrgDetails.reducer';
import { getAssessmentOrganisationReducer } from './SuperAdmin/AddOrganisation/getAssessmentOrganisation.reducer';
import { getAnalyticsOrganisationReducer } from './SuperAdmin/AddOrganisation/getAnalyticsOrganisation.reducer';
import { addAssessmentOrganisationReducer } from './SuperAdmin/AddOrganisation/addAssessmentOrganisation.reducer';
import { removeAssessmentOrganisationReducer } from './SuperAdmin/AddOrganisation/removeAssessmentOrganisation.reducer';
import { getAnalyticsOrgBatchesReducer } from './SuperAdmin/ManageBatches/getAnalyticsOrgBatches.reducer';
import { addAnalyticsActiveBatchesReducer } from './SuperAdmin/ManageBatches/addAnalyticsActiveBatches.reducer';
import { getAnalyticsActiveBatchesReducer } from './SuperAdmin/ManageBatches/getAnalyticsActiveBatches.reducer';
import { removeAnalyticsActiveBatches } from './SuperAdmin/ManageBatches/removeAnalyticsActiveBatches.reducer';
import { getOrgAdmins } from './SuperAdmin/ManageOrgAdmins/getOrgAdmins.reducer';
import { addOrgAdminReducer } from './SuperAdmin/ManageOrgAdmins/addOrgAdmin.reducer';
import { makeOrgPrimaryAdmin } from './SuperAdmin/ManageOrgAdmins/makeOrgPrimaryAdmin.reducer';
import { removeOrgAdmin } from './SuperAdmin/ManageOrgAdmins/removeOrgAdmin.reducer';
import { getCreditsReducer } from './SuperAdmin/ManageCredits/getCredits.reducer';
import { addCreditsReducer } from './SuperAdmin/ManageCredits/addCredits.reducer';
import { revokeCreditsReducer } from './SuperAdmin/ManageCredits/revokeCredits.reducer';
import {getMetricsListReducer} from './SuperAdmin/AssignMetric/getMetricList.reducer';
import {getAnalyticsMetricListReducer} from './SuperAdmin/AssignMetric/getAnalyticsmetricList.reducer';
import { getSwotTextReducer } from './SuperAdmin/SwotText/getSwotText.reducer';
import { editSwotTextReducer } from './SuperAdmin/SwotText/editSwotText.reducer';
import { getFocusAreaTextReducer } from './SuperAdmin/FocusAreaText/getFocusAreaText.reducer';
import { editFocusAreaTextReducer } from './SuperAdmin/FocusAreaText/editFocusAreaText.reducer';
import { getReviewQuestionsReducer } from './SuperAdmin/ReviewQuestions/getReviewQuestions.reducer';
import { editReviewQuestionsReducer } from './SuperAdmin/ReviewQuestions/editReviewQuestions.reducer';

import {saveTeamDetailsReducer} from './Analyse/saveTeam/saveTeam.reducer';
import { teamAvailabilityReducer } from './Analyse/saveTeam/availableTeams.reducer';

import {saveModulePermissionsReducer} from './Analyse/saveModulePermission/saveModulePermission.reducer';
import {assessorGroupsReducer} from './Analyse/AssessorList/getAssessorList.reducer';
import {saveAssesorGroupListReducer} from './Analyse/AssessorList/saveAssessorGroupList.reducer';
import {saveAssesorIdsReducer} from './Analyse/AssessorList/saveAssessorIds.reducer';

import {getAnalyzeData} from './Analyze/getAnalyzeData.reducer'
import { singleValidatorReducer} from './Analyze/singleValidator.reducer'
import { reloadValidatorReducer } from './Analyze/reloadValidatorReducer.reducer'

import { lndDataReducer } from './Analyze/l&dData.reducer'
import { collaborationDataReducer } from './Analyze/collaboration.reducer'
import { attritionPredictorReducer } from './Analyze/attritionPredictor.reducer'
import { teamFitmentReducer } from './Analyze/teamFitment.reducer'
import { competencyReducer } from './Analyze/competency.reducer'

//Header permission

import { headerPermissionReducer } from './Analyze/headerPermissionReducer.reducer'

//User List
import { userListReducer } from './Analyze/userList.reducer'

//Competency List
import { competencyListDataReducer } from './Analyze/competencyList.reducer'

//csv upload for team members
import { csvUploadTeamMembers } from './OrgAdmin/TeamMemberUpload/csvUploadTeamMembers';

import { addFilterForm } from './Analyse/AssessorList/add_filter_form.reducer';

import { getPaAnanlyzeTeamListReducer } from './Analyze/getPaAnanlyzeTeamList.reducer'


// virtualTeam
import { virtualTeamList, virtualTeamListMain, virtualTeamEdit } from './VirtualTeams/VirtualTeamList/VirtualTeamList.reducer';
import { virtualTeamCreate } from './VirtualTeams/VirtualTeamCreate/VirtualTeamCreate.reducer';
import { virtualTeamDelete } from './VirtualTeams/VirtualTeamDelete/VirtualTeamDelete.reducer';
import { virtualMemberList, virtualMemberAdd, virtualMemberUpdate } from './VirtualTeams/VirtualTeamMemberList/VirtualTeamMemberList.reducer';
import { virtualMemberSharedWith, virtualMemberShareTeam, virtualMemberShareDel } from './VirtualTeams/VirtualTeamShare/VirtualTeamShare.reducer';
import { virtualTeamFilter } from './VirtualTeams/VirtualTeamFilter/VirtualTeamFilter.reducer';


//Assign Assessor group
import { delAssignMetricReducer } from './SuperAdmin/AssignAssessor/removeAssignAssessorGroup';
import { getAssessment_groupListReducer } from './SuperAdmin/AssignAssessor/getAssessment_groupList';
import { postAssessment_groupListReducer } from './SuperAdmin/AssignAssessor/postAssessment_groupList';

//assign metric org
import { analyticsDefaultMetricListReducer } from './SuperAdmin/AssignMetric/getDropdownListMetric.reducer';
import { addAssignMetricListReducer } from './SuperAdmin/AssignMetric/addNewCompetencyAssignMetric.reducer';
import { editAssignMetricListReducer } from './SuperAdmin/AssignMetric/editExistingCompetencyAssignMetric.reducer';
import { delAssignMetricListReducer } from './SuperAdmin/AssignMetric/delNewCompetencyAssignMetric.reducer';


//define metrci
import { defaultMetricListReducer } from './SuperAdmin/DefineMetric/defaultMetricList.reducer';
import { combinedMetricListReducer } from './SuperAdmin/DefineMetric/combinedMetricList.reducer';
import { combinedMetricAllowReducer } from './SuperAdmin/DefineMetric/combinedMetricAllow.reducer';
import { combinedMetricDenyReducer } from './SuperAdmin/DefineMetric/combinedMetricDeny.reducer'


//orientationReducer
import { orientationReducer } from './Analyze/orientation.reducer';


//Save team for changing relations.
import {  saveStashTeamReducer  } from './Analyse/saveTeam/saveStashTeam.reducer';
import { team_id_group_list } from './Analyse/saveTeam/team_id_list_on_relation.reducer';


//role fitment
import { role_user_FitmentReducer } from './Analyze/role_fitment_user.reducer';
import { holder_user_FitmentReducer } from './Analyze/role_holder_user.reducer';
import { role_fitment_data_Reducer } from './Analyze/role_fitment_data.reducer';


//collaboration
import { collaborationMainDataReducer } from './Analyze/collaborationData.reducer';

const rootReducer = combineReducers({
  authentication,
  users,
  alert,

  addOrgReducer,
  getOrgReducer,
  getCountryListReducer,

  setPasswordReducer,
  forgotPasswordReducer,

  getOrgTeams,
  addOrgTeamReducer,
  editOrgTeamReducer,
  removeOrgTeamReducer,

  getMemberLevel,
  changeMemberLevelReducer,

  getTeamMemberListReducer,
  moveToDifferentTeamReducer,
  resetTeamLeaderReducer,
  makeTeamLeaderReducer,

  getOrgUsers,
  addPaUsers,
  removePaUsers,
  getPaUserPermissionListReducer,
  changeAccessReducer,
  getMasterModuleListReducer,
  getModulePermissionsListReducer,
  changeModuleAccessReducer,
  toggleAnalysisReducer,

  getOrgDetailsReducer,
  editOrgDetailsReducer,
  deleteOrgDetailsReducer,

  getAssessmentOrganisationReducer,
  getAnalyticsOrganisationReducer,
  addAssessmentOrganisationReducer,
  removeAssessmentOrganisationReducer,

  getAnalyticsOrgBatchesReducer,
  addAnalyticsActiveBatchesReducer,
  getAnalyticsActiveBatchesReducer,
  removeAnalyticsActiveBatches,

  getOrgAdmins,
  addOrgAdminReducer,
  makeOrgPrimaryAdmin,
  removeOrgAdmin,

  getCreditsReducer,
  addCreditsReducer,
  revokeCreditsReducer,

  getMetricsListReducer,
  getAnalyticsMetricListReducer,
 

  getSwotTextReducer,
  editSwotTextReducer,

  getFocusAreaTextReducer,
  editFocusAreaTextReducer,

  getReviewQuestionsReducer,
  editReviewQuestionsReducer,

  saveTeamDetailsReducer,
  teamAvailabilityReducer,
  saveModulePermissionsReducer,
  assessorGroupsReducer,

  //csv upload for teammembers
  csvUploadTeamMembers,

  saveAssesorGroupListReducer,
  saveAssesorIdsReducer,

  //Analyze
  getAnalyzeData,
  singleValidatorReducer,
  reloadValidatorReducer,

   //lnd
   lndDataReducer,

   //collaboration
   collaborationDataReducer,

   //Attrition Predictor
   attritionPredictorReducer,

   //user List
   userListReducer,

   //Competency List
   competencyListDataReducer,

   //Competency
   competencyReducer,

   //Team fitment
   teamFitmentReducer,
  //Filter Form
  addFilterForm,

  //HeaderPermission
  headerPermissionReducer,

  //PAAnaTeamList
  getPaAnanlyzeTeamListReducer,


  //Virtual team
  virtualTeamList,
  virtualTeamCreate,
  virtualTeamListMain,
  virtualTeamDelete,
  virtualMemberList,
  virtualMemberAdd,
  virtualMemberUpdate,
  virtualMemberSharedWith,
  virtualMemberShareTeam,
  virtualMemberShareDel,
  virtualTeamEdit,
  virtualTeamFilter,


  //assign assessor
  delAssignMetricReducer,
  getAssessment_groupListReducer,
  postAssessment_groupListReducer,


  //assign metric
  analyticsDefaultMetricListReducer,
  addAssignMetricListReducer,
  editAssignMetricListReducer,
  delAssignMetricListReducer,
  

  //define metric
  defaultMetricListReducer,
  combinedMetricListReducer,
  combinedMetricAllowReducer,
  combinedMetricDenyReducer,

  //orientationReducer
  orientationReducer,

  //stash team
  saveStashTeamReducer,
  team_id_group_list,


  //role fitment reducers
  role_user_FitmentReducer,
  holder_user_FitmentReducer,
  role_fitment_data_Reducer,


  //collaboration
  collaborationMainDataReducer

});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/_reducers/index.js